import React from "react";
import { MapPin, Clock } from "lucide-react";

const ContactSection = ({ isDarkMode = false }) => {
  const scrollToTop = () => {
    if (window.lenis?.scrollTo) {
      window.lenis.scrollTo(0, { duration: 1.2 });
      return;
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section
      id="contact"
      className={`py-6 lg:py-12 relative overflow-hidden font-['Poppins'] ${
        isDarkMode ? "bg-black" : "bg-white"
      }`}
      style={{ fontFamily: "Poppins, sans-serif" }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <h2
            className={`text-4xl sm:text-5xl lg:text-6xl font-semibold mb-8 ${
              isDarkMode ? "text-white" : "text-gray-900"
            }`}
          >
           Connect Us.
          </h2>
          <p
            className={`text-lg sm:text-xl max-w-3xl mx-auto leading-relaxed ${
              isDarkMode ? "text-gray-300" : "text-gray-600"
            }`}
          >
            Ready to transform your construction career? <br/>Connect with us &
            join India's largest construction community.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-12 animate-fade-in-up">
          {/* Contact Information */}
          <div className="space-y-8">
            <div className="group">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br bg-[#FEF200] rounded-full flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-all duration-300">
                  <MapPin className="w-6 h-6 text-black" />
                </div>
                <div>
                  <h3
                    className={`text-xl font-semibold mb-3 group-hover:bg-[#FEF200] transition-colors duration-300 ${
                      isDarkMode ? "text-white" : "text-gray-900"
                    }`}
                  >
                    Email Address
                  </h3>
                  <a
                    href="mailto:abijith@homeeera.com"
                    className="font-medium text-lg hover:text-yellow-500 transition-colors duration-300 cursor-pointer"
                  >
                    abijith@homeeera.com
                  </a>
                </div>
              </div>
            </div>

            <div className="group">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br bg-[#FEF200] rounded-full flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-all duration-300">
                  <Clock className="w-6 h-6 text-black" />
                </div>
                <div>
                  <h3
                    className={`text-xl font-semibold mb-3 group-hover:bg-[#FEF200] transition-colors duration-300 ${
                      isDarkMode ? "text-white" : "text-gray-900"
                    }`}
                  >
                    Working Hours
                  </h3>
                  <div
                    className={`font-medium text-lg ${
                      isDarkMode ? "text-gray-300" : "text-gray-600"
                    }`}
                  >
                    10:00AM to 05:00PM
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`p-6 rounded-2xl ${
                isDarkMode ? "bg-gray-800" : "bg-white"
              } shadow-lg`}
            >
              <h4
                className={`text-lg font-semibold mb-4 ${
                  isDarkMode ? "text-white" : "text-gray-900"
                }`}
              >
                Quick Response Guarantee
              </h4>
              <p
                className={`text-sm leading-relaxed ${
                  isDarkMode ? "text-gray-300" : "text-gray-600"
                }`}
              >
                We respond to all inquiries within 24 hours. For urgent matters,
                please call us directly or send us a WhatsApp message.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <div className="fixed bottom-8 right-8 z-50">
        <button
          onClick={scrollToTop}
          className={`w-12 h-12 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 hover:scale-110 ${
            isDarkMode
              ? "bg-gray-800 hover:bg-gray-700 text-white"
              : "bg-black hover:bg-gray-800 text-white"
          }`}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 15l7-7 7 7"
            />
          </svg>
        </button>
      </div>

      <style jsx>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
          opacity: 0;
        }
      `}</style>
    </section>
  );
};

export default ContactSection;
